function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2780",
    d: "M12 2 1 20h22z",
    style: {
      fill: "#fff",
      stroke: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2781",
    d: "M12 6l7 12H5z",
    style: {
      fill: "#529f40"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreePoint);
export default __webpack_public_path__ + "static/media/tree-point.94732a6dc7f6c27423dbefcb3f8d3544.svg";
export { ForwardRef as ReactComponent };